import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';

import InnerLoader from './../../APP/COMPONENTS/InnerLoader';
import * as helpers from "./../../APP/HELPERS/functions"

function mapStateToProps(state) {
    return {
        USER: state.USER,
        SHOW_ELEMENTS: state.SHOW_ELEMENTS
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class InfoModal extends Component {

    /// CONSTRUCTOR ///
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        if (!this.props.data) {
            return null
        }

        return (
            <div className="absolute_modal">
                <div className="absolute_modal_overlay" onClick={ () => this.props.close() }></div>
                <div className="absolute_modal_body">
                    <img className="blue_cross" src="/system_images/blue_cross.png" onClick={ () => this.props.close() } />
                    <h3>{ this.props.data.title }</h3>
                    <div className="infoRow">
                        { this.props.data.data.map((item, index) => {
                            return (
                                <div className="infoCard" key={ index }>
                                    <div>{ item.date }</div>
                                    <div className="infoValue">{ item.value }</div>
                                </div>
                            )
                        }) }
                    </div>
                </div>
            </div>
        );
    }

}

export default connect(
    mapStateToProps, mapDispatchToProps
)(InfoModal);
